(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artzova-collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('artzova-filter-dropdown')) {
    customElements.define('artzova-filter-dropdown', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const details = this.querySelector('.artzova-filters__disclosure');
        const summary = details?.querySelector('summary');
        if (!details || !summary) return;
        document.addEventListener('pointerdown', (event) => {
          if (details.open && !this.contains(event.target)) details.open = false;
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            details.open = false;
            summary.focus();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) details.open = false;
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["artzova-judge-me-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = "main[data-template*='product'] .jdgm-review-widget";
    const labels = document.querySelector('[data-artzova-review-labels]')?.dataset;
    let lastLightboxOpen = 0;

    const closeLightbox = (lightbox) => {
      const lightboxImage = lightbox?.querySelector('[data-artzova-review-lightbox-image]');
      if (lightbox?.open) lightbox.close();
      lightboxImage?.removeAttribute('src');
      if (lightboxImage) lightboxImage.alt = '';
    };

    const getReviewImage = (target) => {
      const trigger = target.closest(
        '.jm-review-item button:has(img), .jm-review-item [role="button"]:has(img), .artzova-other-review-card button:has(img), .artzova-other-review-card [role="button"]:has(img), .artzova-other-review-card img'
      );
      if (!trigger?.closest(selector)) return null;
      return trigger.matches('img') ? trigger : trigger.querySelector('img');
    };

    const openLightbox = (event) => {
      const reviewImage = getReviewImage(event.target);
      if (!reviewImage) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const now = Date.now();
      if (now - lastLightboxOpen < 350) return;
      lastLightboxOpen = now;

      const lightbox = document.querySelector('[data-artzova-review-lightbox]');
      const lightboxImage = lightbox?.querySelector('[data-artzova-review-lightbox-image]');
      if (!lightbox || !lightboxImage) return;

      const imageUrl = new URL(reviewImage.currentSrc || reviewImage.src, window.location.href);
      imageUrl.searchParams.delete('width');
      imageUrl.searchParams.delete('height');
      imageUrl.searchParams.set('quality', '95');
      lightboxImage.src = imageUrl.toString();
      lightboxImage.alt = reviewImage.alt || '';
      if (lightbox.dataset.artzovaInitialized !== 'true') {
        lightbox.dataset.artzovaInitialized = 'true';
        lightbox.addEventListener('close', () => closeLightbox(lightbox));
      }
      if (!lightbox.open) lightbox.showModal();
    };

    document.addEventListener('pointerup', openLightbox, true);
    document.addEventListener('click', openLightbox, true);

    document.addEventListener(
      'click',
      (event) => {
        const lightbox = document.querySelector('[data-artzova-review-lightbox]');
        if (event.target.closest('[data-artzova-review-lightbox-close]') || event.target === lightbox) {
          closeLightbox(lightbox);
        }
      },
      true
    );

    const openReviewForm = (widget) => {
      widget.dataset.artzovaOpeningReview = 'true';
      const productTab = widget.querySelector('#jdgm-tab_product_reviews');
      if (productTab?.getAttribute('aria-selected') !== 'true') productTab?.click();

      let attempts = 0;
      const clickNativeButton = () => {
        const nativeButton = widget.querySelector('[data-testid="write-review-button"]');
        if (nativeButton) {
          nativeButton.click();
          window.setTimeout(() => delete widget.dataset.artzovaOpeningReview, 800);
          return;
        }

        attempts += 1;
        if (attempts < 30) {
          window.setTimeout(clickNativeButton, 100);
        } else {
          delete widget.dataset.artzovaOpeningReview;
        }
      };

      window.setTimeout(clickNativeButton, 100);
    };

    const preserveReviewButton = (widget) => {
      const nativeButton = widget.querySelector('[data-testid="write-review-button"]');
      const actionContainer = widget.querySelector('.jm-review-widget-minimal-header__button-and-filters');
      const persistentButton = widget.querySelector('[data-artzova-write-review]');

      if (nativeButton?.textContent.trim()) {
        widget.dataset.artzovaReviewButtonLabel = nativeButton.textContent.trim();
        persistentButton?.remove();
        return nativeButton;
      }

      if (!actionContainer || persistentButton || !widget.dataset.artzovaReviewButtonLabel) return null;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'jm-button jm-button--primary jm-action-buttons__button';
      button.dataset.artzovaWriteReview = 'true';
      button.textContent = widget.dataset.artzovaReviewButtonLabel;
      button.addEventListener('click', () => openReviewForm(widget));
      actionContainer.append(button);
      return button;
    };

    const setActiveTab = (widget, selectedTab) => {
      widget.querySelectorAll('.jdgm-tab').forEach((tab) => {
        const active = tab === selectedTab;
        tab.classList.toggle('jdgm-tab--active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
    };

    const removeHeaderMediaPreview = (widget) => {
      const header = widget.querySelector('.jm-review-widget__header');
      if (!header) return;

      header
        .querySelectorAll("[class*='media'], [class*='carousel'], [class*='gallery'], [class*='image-preview'], [class*='photo-preview']")
        .forEach((element) => {
          if (!element.closest('.jm-average-rating-display')) element.remove();
        });

      header.querySelectorAll('button').forEach((button) => {
        const label = button.getAttribute('aria-label') || '';
        if (/previous|next|photo|image|media/i.test(label)) button.remove();
      });

      header.querySelectorAll('img').forEach((image) => {
        if (image.closest('.jm-average-rating-display')) return;
        const container = image.closest('div');
        if (container && container !== header) container.remove();
        else image.remove();
      });
    };

    const getSourceReviewCards = (source) =>
      Array.from(
        source?.querySelectorAll(
          '.jdgm-carousel-item:not(.jdgm-clone-before):not(.jdgm-clone-after), .jdgm-card:not(.jdgm-clone-before):not(.jdgm-clone-after)'
        ) || []
      ).filter((card) => !card.closest('.jdgm-carousel-item') || card.matches('.jdgm-carousel-item'));

    const getProductReviewCount = (widget) => {
      const ratingCountText = Array.from(
        widget.querySelectorAll('.jm-average-rating-display .jm-text')
      )
        .map((element) => element.textContent.trim())
        .find((text) => /[\d,]+\s+reviews?/i.test(text));
      const ratingCountMatch = ratingCountText?.match(/([\d,]+)\s+reviews?/i);
      if (ratingCountMatch) return Number(ratingCountMatch[1].replaceAll(',', ''));

      return widget.querySelectorAll('.jm-review-item').length;
    };

    const getOtherProductReviewCount = (source, sourceCards, displayedCount, productCount) => {
      const aggregateMatches = Array.from(source.textContent.matchAll(/\(([\d,]+)\)/g)).map((match) =>
        Number(match[1].replaceAll(',', ''))
      );
      const aggregateCount = aggregateMatches.length ? Math.max(...aggregateMatches) : 0;
      if (aggregateCount > sourceCards.length) return Math.max(displayedCount, aggregateCount - productCount);
      return displayedCount;
    };

    const addCarouselControls = (track) => {
      if (!track) return null;
      const existingShell = track.closest('.artzova-review-carousel-shell');
      if (existingShell) return existingShell;

      const shell = document.createElement('div');
      shell.className = 'artzova-review-carousel-shell';
      shell.dataset.artzovaReviewCarousel = 'true';

      const previousButton = document.createElement('button');
      previousButton.type = 'button';
      previousButton.className = 'artzova-review-carousel-arrow artzova-review-carousel-arrow--previous';
      previousButton.setAttribute('aria-label', labels?.previousReviews || 'Previous reviews');
      previousButton.innerHTML = '&#8249;';

      const nextButton = document.createElement('button');
      nextButton.type = 'button';
      nextButton.className = 'artzova-review-carousel-arrow artzova-review-carousel-arrow--next';
      nextButton.setAttribute('aria-label', labels?.nextReviews || 'Next reviews');
      nextButton.innerHTML = '&#8250;';

      track.insertAdjacentElement('beforebegin', shell);
      shell.append(previousButton, track, nextButton);

      const updateButtons = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = maximumScroll <= 2 || track.scrollLeft >= maximumScroll - 2;
      };

      const move = (direction) => {
        const distance = Math.max(240, track.clientWidth * 0.9);
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };

      previousButton.addEventListener('click', () => move(-1));
      nextButton.addEventListener('click', () => move(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      shell.addEventListener('artzova:refresh', () => window.requestAnimationFrame(updateButtons));
      if ('ResizeObserver' in window) new ResizeObserver(updateButtons).observe(track);
      window.requestAnimationFrame(updateButtons);
      return shell;
    };

    const refreshCarousels = (container) => {
      container?.querySelectorAll('[data-artzova-review-carousel]').forEach((shell) => {
        shell.dispatchEvent(new Event('artzova:refresh'));
      });
    };

    const addCurrentProductLinks = (widget) => {
      const title = labels?.currentProductTitle;
      const url = labels?.currentProductUrl;
      if (!title || !url) return;

      widget.querySelectorAll('.jm-review-item').forEach((review) => {
        if (review.querySelector('[data-artzova-review-product-link]')) return;
        const link = document.createElement('a');
        link.className = 'artzova-review-product-link';
        link.dataset.artzovaReviewProductLink = 'true';
        link.href = url;
        link.textContent = title;
        review.append(link);
      });
    };

    const showProductReviews = (widget, productTab, panel) => {
      panel.hidden = true;
      const body = widget.querySelector('.jm-review-widget__body');
      body?.classList.remove('artzova-native-reviews--hidden');
      setActiveTab(widget, productTab);
      refreshCarousels(body);
    };

    const showOtherProductReviews = (widget, otherTab, panel) => {
      const body = widget.querySelector('.jm-review-widget__body');
      body?.classList.add('artzova-native-reviews--hidden');
      panel.hidden = false;
      setActiveTab(widget, otherTab);
      refreshCarousels(panel);
    };

    const syncReviewTabs = (widget, panel) => {
      const productTab = widget.querySelector('#jdgm-tab_product_reviews');
      const otherTab = widget.querySelector('#artzova-tab_other_product_reviews');
      const source = document.querySelector("[id*='artzova_other_product_reviews_source'] .jdgm-cards-carousel");
      const track = panel?.querySelector('.artzova-other-reviews-track');
      if (!productTab || !otherTab || !panel || !source) return;

      const productCount = getProductReviewCount(widget);
      const sourceCards = getSourceReviewCards(source);
      const otherCount = getOtherProductReviewCount(source, sourceCards, track?.childElementCount || 0, productCount);

      const productLabel = `${labels?.productReviews || 'This product reviews'} (${productCount.toLocaleString()})`;
      const otherLabel = `${labels?.otherProductReviews || 'Other product reviews'} (${otherCount.toLocaleString()})`;
      if (productTab.textContent !== productLabel) productTab.textContent = productLabel;
      if (otherTab.textContent !== otherLabel) otherTab.textContent = otherLabel;

      const productIsEmpty = productCount === 0;
      productTab.classList.toggle('artzova-review-tab--empty', productIsEmpty);
      const disabledValue = productIsEmpty ? 'true' : 'false';
      if (productTab.getAttribute('aria-disabled') !== disabledValue) {
        productTab.setAttribute('aria-disabled', disabledValue);
      }
      if ('disabled' in productTab && productTab.disabled !== productIsEmpty) productTab.disabled = productIsEmpty;

      const userSelected = widget.dataset.artzovaReviewTabUserSelected === 'true';
      const productIsActive = productTab.getAttribute('aria-selected') === 'true';
      const otherIsActive = otherTab.getAttribute('aria-selected') === 'true';
      if (!userSelected) {
        if (productIsEmpty && !otherIsActive) showOtherProductReviews(widget, otherTab, panel);
        else if (!productIsEmpty && !productIsActive) showProductReviews(widget, productTab, panel);
      } else if (productIsEmpty && productIsActive) {
        showOtherProductReviews(widget, otherTab, panel);
      }
    };

    const buildOtherProductReviews = (widget) => {
      const existingPanel = widget.querySelector('[data-artzova-other-reviews-panel]');
      if (existingPanel) {
        syncReviewTabs(widget, existingPanel);
        return existingPanel;
      }

      const source = document.querySelector("[id*='artzova_other_product_reviews_source'] .jdgm-cards-carousel");
      const body = widget.querySelector('.jm-review-widget__body');
      if (!source || !body) return null;

      widget.querySelector('#jdgm-tab_shop_reviews')?.remove();

      let tabList = widget.querySelector('.jdgm-tablist__list');
      if (!tabList) {
        const tabViewport = document.createElement('div');
        tabViewport.className = 'jdgm-tablist__viewport artzova-review-tablist';
        tabList = document.createElement('div');
        tabList.className = 'jdgm-tablist__list';
        tabList.setAttribute('role', 'tablist');
        tabViewport.append(tabList);
        body.insertAdjacentElement('beforebegin', tabViewport);
      }

      const nativeProductReviewCount = getProductReviewCount(widget);
      let productTab = widget.querySelector('#jdgm-tab_product_reviews');
      if (!productTab) {
        productTab = document.createElement('button');
        productTab.type = 'button';
        productTab.id = 'jdgm-tab_product_reviews';
        productTab.className = 'jdgm-tab jdgm-tab--active';
        productTab.textContent = `${labels?.productReviews || 'Product reviews'} (${nativeProductReviewCount})`;
        tabList.prepend(productTab);
      }

      body.id = body.id || 'artzova-product-reviews-panel';
      productTab.setAttribute('role', 'tab');
      productTab.setAttribute('aria-controls', body.id);
      productTab.setAttribute('aria-selected', 'true');

      const panel = document.createElement('section');
      panel.className = 'artzova-other-reviews-panel';
      panel.dataset.artzovaOtherReviewsPanel = 'true';
      panel.id = 'artzova-other-product-reviews-panel';
      panel.setAttribute('role', 'tabpanel');
      panel.hidden = true;

      const track = document.createElement('div');
      track.className = 'artzova-other-reviews-track';
      track.setAttribute('aria-live', 'polite');

      const sourceCards = getSourceReviewCards(source);
      if (!sourceCards.length) return null;
      const seen = new Set();

      sourceCards.forEach((sourceCard) => {
        const productLink = sourceCard.querySelector('a[href*="/products/"]');
        if (!productLink) return;

        const productUrl = new URL(productLink.href, window.location.href);
        if (productUrl.pathname === window.location.pathname) return;

        const signature = `${productUrl.pathname}|${sourceCard.textContent.trim()}`;
        if (seen.has(signature)) return;
        seen.add(signature);

        const card = document.createElement('article');
        card.className = 'artzova-other-review-card';
        card.append(sourceCard.cloneNode(true));
        track.append(card);
      });

      if (track.childElementCount) {
        panel.append(track);
        addCarouselControls(track);
      } else {
        const empty = document.createElement('p');
        empty.className = 'artzova-other-reviews-empty';
        empty.textContent = labels?.noOtherProductReviews || 'No other product reviews yet.';
        panel.append(empty);
      }

      body.insertAdjacentElement('afterend', panel);

      const otherTab = document.createElement('button');
      otherTab.type = 'button';
      otherTab.id = 'artzova-tab_other_product_reviews';
      otherTab.className = 'jdgm-tab';
      otherTab.setAttribute('role', 'tab');
      otherTab.setAttribute('aria-controls', panel.id);
      otherTab.setAttribute('aria-selected', 'false');
      otherTab.tabIndex = -1;
      otherTab.textContent = labels?.otherProductReviews || 'Other product reviews';
      tabList.append(otherTab);

      productTab.addEventListener(
        'click',
        (event) => {
          if (getProductReviewCount(widget) === 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          widget.dataset.artzovaReviewTabUserSelected = 'true';
          showProductReviews(widget, productTab, panel);
        },
        true
      );
      otherTab.addEventListener('click', () => {
        widget.dataset.artzovaReviewTabUserSelected = 'true';
        showOtherProductReviews(widget, otherTab, panel);
      });

      syncReviewTabs(widget, panel);

      return panel;
    };

    const enhanceWidgets = () => {
      document.querySelectorAll(selector).forEach((widget) => {
        widget.classList.add('artzova-judge-me--enhanced');
        removeHeaderMediaPreview(widget);
        preserveReviewButton(widget);
        addCurrentProductLinks(widget);
        widget.querySelector('#jdgm-tab_shop_reviews')?.remove();
        addCarouselControls(widget.querySelector('.jdgm-review-list'));
        buildOtherProductReviews(widget);
      });
    };

    enhanceWidgets();

    const observer = new MutationObserver(enhanceWidgets);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', enhanceWidgets);
  })();
  } catch(e) { console.error(e); }
})();

})();
